import {
    SET_LOADING, SET_STAMPS, SET_STAMPS_TOTAL, SET_STAMP
} from "./mutations";
import ApiService from "@/core/services/ApiService";

export default {
    async fetchSupervisorStampForms({commit}, params = {}) {
        commit(SET_LOADING, true);
        ApiService.setHeader();
        return await ApiService.query("supervisor/stamps", params)
            .then((result) => {
                result = result.data;
                commit(SET_STAMPS, result?.data ?? []);
                commit(SET_STAMPS_TOTAL, result?.total ?? []);
                commit(SET_LOADING, false);

                return result;
            })
            .catch(({response}) => {
                // console.log('error response', response);
                commit(SET_LOADING, false);
            });
    },
    async fetchSupervisorStampFormExport({commit}, params = {}) {
        commit(SET_LOADING, true);
        ApiService.setHeader();
        return await ApiService.export("supervisor/stamps/export", params)
            .then((result) => {
                console.log(result.data)
                const blob = new Blob([result.data], {type: "application/xlsx"});
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = params.label;
                link.click();
                URL.revokeObjectURL(link.href);
            })
            .catch(({response}) => {
                // console.log('error response', response);
                commit(SET_LOADING, false);
            });
    },
    async fetchSupervisorStampForm({commit}, id) {
        commit(SET_LOADING, true);
        ApiService.setHeader();
        return await ApiService.get(`supervisor/stamps/${id}`)
            .then((result) => {
                commit(SET_STAMP, result?.data ?? {});
                commit(SET_LOADING, false);
                return result;
            })
            .catch(({response}) => {
                // console.log('error response', response);
                commit(SET_STAMP, {success: false});

            });
    },
    async updateSupervisorStampForm({commit}, params) {
        commit(SET_LOADING, true);
        ApiService.setHeader();
        return await ApiService.put("supervisor/stamps/" + params.apply_form_id, params)
            .then((result) => {
                result = result.data;
                return result;
            })
            .catch(({response}) => {
                // console.log('error response', response.data);
                return response.data;
            });
    },
};
